<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="msg-view">
                        <p>{{ text }}</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal" v-if="type == 1"></div>
                        <div class="u-btn charge" v-if="type !=1 && ($store.state.userinfo.fromType == 0)"><a href="https://pay.17m3.com/" target="_blank" rel="noopener noreferrer"></a></div>
                        <div class="u-btn ok" v-if="type !=1 && ($store.state.userinfo.fromType != 0)" @click="closeModal"></div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.msg-modal{
    position: relative;
    width: 578px;
    height: 332px;
    font-size: 24px;
    color: #6f3615;
    background-image: url(~@/assets/images/bg-extra.png);
}

.title{
    width: 195px;
    height: 28px;
    margin: 15px auto 24px;
    background-image: url(~@/assets/images/title-error.png);    
}

.msg-view{
    padding: 10px 30px 0;
    line-height: 1.8;
    font-size: 24px;
    color: #3f2a0e;
    text-align: center;
}

.msg-view b{
    color: #fe5a1e;
}

.msg-view .icon{
    display: inline-block;
    width: 31px;
    height: 30px;
    margin: 0 5px;
    background-image: url(~@/assets/images/icon-m3b.png);
    vertical-align: sub;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.ok{
    width: 225px;
    height: 60px;
    margin: 48px auto 0;
    background-image: url(~@/assets/images/btn-ok.png);    
}

.u-ctrl .u-btn.charge{
    width: 225px;
    height: 60px;
    margin: 48px auto 0;
    background-image: url(~@/assets/images/btn-charge.png);    
}

.u-btn.charge a{
    display: block;
    width: 100%;
    height: 100%;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 1,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/ErrorModal/errorModal.vue